import type { ReceiptTemplate } from '../schema';

export const airbnbTemplate: ReceiptTemplate = {
  id: 'airbnb',
  name: 'Airbnb Receipt',
  brand: 'AIRBNB',
  description: 'Vacation rental receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'airbnb-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 50,
        businessName: 'airbnb',
        businessNameFontSize: 24,
        addressLines: [
          'Reservation Receipt',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'airbnb-conf',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Confirmation Code: HM8X4K2N',
        fontSize: 14,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'airbnb-property',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Property:\nCozy Downtown Loft with City View\n\nHost: James S.\n\nAddress:\n500 Scare Floor Blvd, Apt 12B\nSan Francisco, CA 94102',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'airbnb-dates',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Check-in: Jan 4, 2026 (3:00 PM)\nCheckout: Jan 7, 2026 (11:00 AM)\nGuests: 2\nNights: 3',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'airbnb-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 45,
        labelAlignment: 'left',
        lines: [
          { id: 'airbnb-nightly', label: '$150 x 3 nights', value: '450.00', isBold: false, isLarge: false },
          { id: 'airbnb-cleaning', label: 'Cleaning fee', value: '75.00', isBold: false, isLarge: false },
          { id: 'airbnb-service', label: 'Service fee', value: '74.03', isBold: false, isLarge: false },
          { id: 'airbnb-tax', label: 'Occupancy taxes', value: '53.91', isBold: false, isLarge: false },
          { id: 'airbnb-total', label: 'Total (USD)', value: '652.94', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 15,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'airbnb-payment',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Payment Method:\nVisa ****4144\n\nPaid: January 2, 2026',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'airbnb-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Questions? Contact Airbnb Support\nairbnb.com/help',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

